var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.componentType,_vm._b({tag:"component",attrs:{"field":_vm.field},scopedSlots:_vm._u([{key:"error",fn:function(){return [_vm._t("error")]},proxy:true}],null,true)},'component',_vm.componentProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }